import React, {Component} from 'react';

import './Public.css';
import Layout from "./public/Layout";
import connect from "react-redux/es/connect/connect";
import BrandUtil from "./services/BrandUtil";

const LOGIN_CLASS = "login-bg";
const BODY_MINI_CLASS = "body-mini";
const BODY_BMW_CLASS = "body-bmw";

class Public extends Component {

  constructor(props) {
    super(props);
    const brand = BrandUtil.resolveBrand().toLowerCase();
    document.body.classList.add(LOGIN_CLASS);
    document.body.classList.remove(BODY_MINI_CLASS);
    document.body.classList.remove(BODY_BMW_CLASS);
    document.body.classList.add(brand === 'mini' ? BODY_MINI_CLASS : BODY_BMW_CLASS);
  }

  componentDidMount() {
    this.props.dispatchFetchFrontendConfig();
  }

  componentWillUnmount() {
    document.body.classList.remove(LOGIN_CLASS);
    document.body.classList.remove(BODY_MINI_CLASS);
    document.body.classList.remove(BODY_BMW_CLASS);
  }

  componentWillReceiveProps(nextProps) {
    const brand = BrandUtil.resolveBrand().toLowerCase();
    document.body.classList.remove(BODY_MINI_CLASS);
    document.body.classList.remove(BODY_BMW_CLASS);
    document.body.classList.add(brand === 'mini' ? BODY_MINI_CLASS : BODY_BMW_CLASS);
  }

  render() {
    return (
      <Layout/>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  dispatchFetchFrontendConfig: () => dispatch({type: 'FETCH_FRONTEND_CONFIG.REQUEST'}),

});

const mapStateToProps = state => ({
  brand: state.publicContext && state.publicContext.brand,
});

export default connect(mapStateToProps, mapDispatchToProps)(Public);

